// CreateBlogPage.js
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Input from "@mui/material/Input";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import TinyMCEEditor from "../../components/TinyMCEEditor";
import FormControl from "@mui/material/FormControl";
import { uploadData } from "aws-amplify/storage";
import { v4 as uuidv4 } from "uuid";
export const CreateBlogPage = () => {
  const navigator = useNavigate();
  const [imageFile, setImageFile] = useState(null);
  const [richTextContent, setRichTextContent] = useState("");
  const [avatarSrc, setAvatarSrc] = React.useState();
  const { blogId } = useParams();
  const [blogData, setBlogData] = useState({
    title: "",
    content: "",
    richTextContent: "",
    tags: "",
    like: 0,
    read_time: 0,
    items: [],
    user_id: {
      _id: "654ce4fc51b83204e9735c45", // Assuming user is already logged in
      name: "Nishchay Rajput",
      email: "nishchayr@gmail.com",
    },
  });
  const generateUniqueKey = () => {
    const uniqueKey = uuidv4();
    return uniqueKey;
  };

  const navigate = useNavigate();
  useEffect(() => {
    async function getInfo() {
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/verify`,
          {
            withCredentials: true,
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );
        if (data.message === "Please login first") {
          navigate("/adminLogin");
        }
      } catch (error) {
        console.log(error);
      }
    }
    getInfo();
  }, []);
  const image_id = generateUniqueKey();
  const richtext_id = generateUniqueKey();
  useEffect(() => {
    if (blogData?.richTextContent) {
      fetch(blogData.richTextContent)
        .then((response) => response.text())
        .then((content) => setRichTextContent(content))
        .catch((error) =>
          console.error("Error fetching rich text content:", error)
        );
    } else {
      setRichTextContent(""); // Set an initial empty string
    }
  }, [blogData?.richTextContent]);
  const uploadImageToS3 = async () => {
    try {
      const imageKey = `images/${image_id}_${imageFile.name}`;
      const res = uploadData({
        key: imageKey,
        data: imageFile,
        options: {
          contentType: imageFile.type,
          acl: "public-read",
        },
      });
      console.log(res);
    } catch (error) {
      console.error("Error uploading image:", error);
      throw error;
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setBlogData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setImageFile(file);
    setAvatarSrc(URL.createObjectURL(file));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let newData = {};
    if (imageFile) {
      await uploadImageToS3();
      newData = {
        ...blogData,
        items: [
          {
            s3Key: `public/images/${image_id}_${imageFile.name}`,
            bucket: process.env.REACT_APP_AWS_BUCKET,
            mime: imageFile.type,
            region: process.env.REACT_APP_AWS_REGION,
            dateCreated: new Date(),
          },
        ],
      };
    } else {
      newData = {
        ...blogData,
      };
    }
    try {
      // Send a POST request to the backend to create a new blog
      const richTextContentKey = `richTextContent/${richtext_id}.txt`;
      const res = uploadData({
        key: richTextContentKey,
        data: richTextContent,
        options: {
          contentType: "text/plain",
          acl: "public-read",
        },
      });
      const data = {
        ...newData,
        richTextContent: `https://${process.env.REACT_APP_AWS_BUCKET}.s3.${process.env.REACT_APP_AWS_REGION}.amazonaws.com/public/richTextContent/${richtext_id}.txt`,
      };

      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/blogs`,
        data,
        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );

      navigator("/home");
      // You can redirect the user to the newly created blog or any other page
    } catch (error) {
      console.error("Error creating new blog:", error);
    }
  };

  return (
    <div>
      <Typography variant="h4">Create New Blog</Typography>
      <form onSubmit={handleSubmit}>
        <TextField
          fullWidth
          margin="normal"
          label="Title"
          name="title"
          value={blogData.title}
          onChange={handleChange}
        />
        <TextField
          fullWidth
          margin="normal"
          label="Content"
          name="content"
          multiline
          rows={4}
          value={blogData.content}
          onChange={handleChange}
        />
        <TinyMCEEditor
          value={richTextContent}
          onChange={(content) => setRichTextContent(content)}
        />
        {/* Add TinyMCE editor or another rich text editor for 'richTextContent' */}
        <TextField
          fullWidth
          margin="normal"
          label="Tags"
          name="tags"
          value={blogData.tags}
          onChange={handleChange}
        />
        <TextField
          fullWidth
          margin="normal"
          label="Read Time (minutes)"
          name="read_time"
          type="number"
          value={blogData.read_time}
          onChange={handleChange}
        />
        <FormControl fullWidth margin="normal">
          {/* <InputLabel htmlFor="image">Image</InputLabel> */}
          <Input
            type="file"
            accept="image/*"
            id="image"
            onChange={handleImageChange}
            style={{ display: "none" }}
          />
          <label htmlFor="image">
            <Button
              variant="outlined"
              component="span"
              startIcon={<CloudUploadIcon />}
            >
              Upload Image
            </Button>
          </label>
          <img
            src={avatarSrc}
            style={{ width: "12vw", margin: "1.5rem 0px" }}
          />
        </FormControl>
        {/* Add more form fields based on your blog schema */}
        <Button type="submit" variant="contained" color="primary">
          Create Blog
        </Button>
      </form>
    </div>
  );
};
